












































import Vue from 'vue';
import { mapState } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import Header from '@/components/Header.vue';
import Pagination from '@/components/Pagination.vue';

export default Vue.extend({
  components: {
    pxCard,
    Header,
    pxButton,
    ArrowRightIcon,
    SquareEditOutlineIcon,
    Pagination,
    Loading,
  },

  data() {
    return {
      currentPage: 0,
      loaded: false,
      searchTerm: '',
      courseToSearch: '',
    };
  },

  computed: {
    courses() {
      return this.$store.state.courses.courses;
    },
    paginationInformation() {
      return this.$store.state.courses.paginationInformation;
    },
  },

  async mounted() {
    let page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    }

    await this.changePage(this.currentPage);
  },

  methods: {
    async changePage(event: any) {
      this.loaded = false;
      let currentPage = event;
      await this.pullCoursesInPagination(currentPage);
    },

    async pullCoursesInPagination(pageNumber) {
      this.loaded = false;
      this.currentPage = pageNumber;
      await this.$store.dispatch('PULL_COURSES', {
        currentPage: pageNumber,
        numberOfCoursesToShow: 50,
        searchTerm: this.searchTerm,
      });
      this.loaded = true;
      this.$router.push(`/cursos/${pageNumber + 1}`);
    },

    async searchCourse() {
      const currentPage = 0;
      this.searchTerm = this.courseToSearch;
      await this.pullCoursesInPagination(currentPage);
    },

    async removeSearch() {
      this.courseToSearch = '';
      this.searchCourse();
    },

    // removeCourse: async function(courseId: number, index: number) {
    //   if (
    //     confirm(
    //       "Tem certeza que deseja deletar esse curso? Ela não poderá ser recuperada!"
    //     )
    //   ) {
    //     let response = await this.$store.dispatch("REMOVE_COURSE", courseId);
    //     if (response === true) {
    //       this.$store.commit("REMOVE_COURSE", index);
    //     } else {
    //       //TODO analyze the error
    //       console.log(response);
    //       alert("Esse curso não pode ser deletada!");
    //     }
    //   }
    // }
  },
});
